export default {"src":"/_next/static/media/warning_40.f49e9543.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};